<template>
  <div>
    <section class="card bg-white rounded mr-lg-3 mb-4 p-3 p-sm-4 col">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h1 class="h2 mb-3">{{my ? 'My ' : '' }}Membership Details</h1>
        <router-link tag="button" :to="{ name: 'Add Members', params: { memberDetails: memberDetails } }" class="d-block d-lg-none btn btn-primary text-nowrap">Add<span class="d-none d-md-inline"> Member/s</span></router-link>
      </div>
      <div role="alert" class="alert alert-success" v-if="success">{{success}}</div>
      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.first_name + ' ' + row.last_name" :link="'Member Profile'" :slug="row.id" :tab="'loading'" :row="row" :options="{ showLinks: !row.deleted_at, expandMobile: true, showActive: true, showDeleted: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Membership No: </strong>
              <tableTextTemplate :text="row.member_number" :row="row" :options="{ showPrimary: true, inline: true }" />
            </li>
            <li class="pt-3 d-inline-block" v-if="!row.deleted_at">
              <tableButtonTemplate :text="!row.parent_id ? '' : 'Split'" :link="'Member Profile Split'" :row="row" :split="true" />
            </li>
          </ul>
        </div>
      </data-table>
    </section>

    <desktop-action-bar>
      <button @click.prevent="addMembers" class="d-none d-lg-block btn btn-block btn-primary text-nowrap">Add Member/s</button>
    </desktop-action-bar>
  </div>
</template>

<script>
import axios from 'axios'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tableButtonTemplate from '@/components/DataTableFields/Button'
import eventBus from '@/store/EventBus.js'
import DesktopActionBar from '@/components/DesktopActionBar'

export default {
  name: 'MembersProfileMembership',
  props: ['memberDetails', 'my', 'success'],
  components: {
    'data-table': dataTable,
    tableTextTemplate,
    tableButtonTemplate,
    DesktopActionBar
  },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :link="'Member Profile'" :slug="row.id" :tab="'loading'" :row="row" :options="{ showLinks: !row.deleted_at }" />`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :link="'Member Profile'" :slug="row.id" :tab="'loading'" :row="row" :options="{ showLinks: !row.deleted_at, showActive: true, showDeleted: true }" />`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Membership No.',
          field: 'member_number',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.member_number" :row="row" :options="{ showPrimary: true }" />`
          }),
          representedAs: 'member_number'
        },
        {
          label: 'Action',
          field: '',
          align: 'left',
          sortable: false,
          filterable: false,
          headerClass: 'column-lg-small d-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableButtonTemplate },
            template: `<tableButtonTemplate v-if="!row.deleted_at" :text="!row.parent_id ? '' : 'Split'" :link="'Member Profile Split'" :row="row" :split="true" />`
          })
        }
      ],
      options: {
        loading: true
      }
    }
  },
  mounted() {
    this.$store.commit('deselectAllRows')
    if (this.memberDetails) {
      this.refreshUserData()
    }

    if (this.$isAdmin) {
      this.columns.splice(-1, 0, {
        label: 'Effective Date',
        field: 'effective_date',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: ({
          props: ['row'],
          components: { tableTextTemplate },
          template: `<tableTextTemplate :text="row.effective_date ? new Date(row.effective_date).toLocaleString('en-AU').substring(0, 10) : ''" :row="row" :options="{ showPrimary: true }" />`
        }),
        representedAs: 'effective_date'
      })
    }
  },
  watch: {
    memberDetails: {
      handler() {
        let tempRows = []
        if (this.memberDetails.primary) {
          tempRows = [this.memberDetails.primary, this.memberDetails, ...this.memberDetails.primary.secondaries]
        } else {
          tempRows = [this.memberDetails, ...this.memberDetails.secondaries]
        }
        tempRows = tempRows.filter((thing, index, self) =>
          index === self.findIndex(t => (
            t.id === thing.id
          ))
        )
        this.rows = [...tempRows]
      },
      deep: true
    }
  },
  methods: {
    addMembers() {
      eventBus.$emit('deselect-all')
      this.$store.commit('deselectAllRows')
      this.$router.push({ name: 'Add Members' })
    },
    // Get user list
    refreshUserData() {
      axios.get(`${this.$api}/user/${this.memberDetails.id}`).then((response) => {
        this.updateList(response.data.data)
      }).catch(() => {
        this.updateList(this.memberDetails)
      })
    },
    // Update user list
    updateList(member) {
      let tempRows = []
      if (member.primary) {
        tempRows = [member.primary, member, ...member.primary.secondaries]
      } else {
        tempRows = [member, ...member.secondaries]
      }
      tempRows = tempRows.filter((thing, index, self) =>
        index === self.findIndex(t => (
          t.id === thing.id
        ))
      )
      tempRows.map(row => row.effective_date = row.user_memberships && row.user_memberships.length ? new Date(Math.max(...row.user_memberships.map(e => new Date(e.effective_date)))) : null)
      this.rows = [...tempRows]
      this.options.loading = false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Members/Tabs/Membership.vue